var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoles(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_547",
    "data-name": "Group 547",
    transform: "translate(-3103 -1056)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26",
    "data-name": "Rectangle 26",
    width: 36,
    height: 36,
    rx: 5,
    transform: "translate(3103 1056)",
    fill: "#ebfbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1256",
    "data-name": "Path 1256",
    d: "M3120.069,1068.434l-1.741,2.163h6.125l-1.441-2.163Z",
    transform: "translate(-6.125 10.461)",
    fill: "#0e7791"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(3113.869 1075.063)",
    fill: "#0e7791"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1257",
    "data-name": "Path 1257",
    d: "M3120.069,1068.434l-1.741,2.163h6.125l-1.441-2.163Z",
    transform: "translate(5.875 9.461)",
    fill: "#0e7791"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(3125.869 1074.063)",
    fill: "#0e7791"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1255",
    "data-name": "Path 1255",
    d: "M3120.01,1068.434l-1.682,2.32h5.917l-1.392-2.32Z",
    fill: "#0e7791"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 1.5,
    cy: 2,
    rx: 1.5,
    ry: 2,
    transform: "translate(3120 1064)",
    fill: "#0e7791"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Roles",
    d: "M18.361,16.492v.375a.375.375,0,0,0,.372-.425Zm-5.961,0-.372-.05a.375.375,0,0,0,.372.425Zm-5.923.959v.375a.375.375,0,0,0,.373-.409ZM3.486,14.828l-.015.375H3.5ZM.5,17.451l-.373-.034a.375.375,0,0,0,.373.409Zm11.889-10.4v.375A.375.375,0,0,0,12.76,7ZM9.409,4.48v0ZM6.428,7.052,6.058,7a.375.375,0,0,0,.371.43Zm-5.467,3.6a.375.375,0,0,0,.746.078ZM5.1,5.339A.375.375,0,1,0,4.709,4.7Zm9.51,13.1a.375.375,0,0,0-.49-.568Zm-8.825.21a.375.375,0,1,0-.377.649ZM14.289,4.8a.375.375,0,0,0-.407.63Zm2.566,4.53a.375.375,0,1,0,.715-.226Zm-.256,2.3a1.224,1.224,0,0,1-1.224,1.224v.75a1.974,1.974,0,0,0,1.974-1.974ZM15.375,12.86a1.224,1.224,0,0,1-1.224-1.224H13.4a1.974,1.974,0,0,0,1.974,1.974Zm-1.224-1.224a1.224,1.224,0,0,1,1.224-1.224v-.75A1.974,1.974,0,0,0,13.4,11.637Zm1.224-1.224A1.224,1.224,0,0,1,16.6,11.637h.75a1.974,1.974,0,0,0-1.974-1.974Zm3.358,6.029a3.383,3.383,0,0,0-1.126-2.094l-.494.565a2.632,2.632,0,0,1,.876,1.63Zm-1.126-2.094a3.383,3.383,0,0,0-2.226-.836v.75a2.632,2.632,0,0,1,1.732.65Zm-2.226-.836a3.383,3.383,0,0,0-2.226.836l.494.565a2.632,2.632,0,0,1,1.732-.65Zm-2.226.836a3.383,3.383,0,0,0-1.126,2.094l.743.1a2.632,2.632,0,0,1,.877-1.63ZM12.4,16.867h5.961v-.75H12.4ZM4.71,12.6a1.224,1.224,0,0,1-1.224,1.224v.75A1.974,1.974,0,0,0,5.46,12.6ZM3.486,13.819A1.224,1.224,0,0,1,2.262,12.6h-.75a1.974,1.974,0,0,0,1.974,1.974ZM2.262,12.6a1.224,1.224,0,0,1,1.224-1.224v-.75A1.974,1.974,0,0,0,1.512,12.6Zm1.224-1.224A1.224,1.224,0,0,1,4.71,12.6h.75a1.974,1.974,0,0,0-1.974-1.974Zm3.365,6.045a3.264,3.264,0,0,0-1.1-2.156l-.494.564A2.514,2.514,0,0,1,6.1,17.485Zm-1.1-2.156a3.264,3.264,0,0,0-2.281-.807l.03.749a2.513,2.513,0,0,1,1.757.622ZM3.5,14.454a3.258,3.258,0,0,0-2.279.808l.495.563A2.508,2.508,0,0,1,3.471,15.2Zm-2.279.808A3.258,3.258,0,0,0,.127,17.418l.747.067a2.508,2.508,0,0,1,.843-1.66ZM.5,17.826H6.477v-.75H.5Zm10.122-15.6A1.224,1.224,0,0,1,9.4,3.447V4.2a1.974,1.974,0,0,0,1.974-1.974ZM9.4,3.447A1.224,1.224,0,0,1,8.174,2.224h-.75A1.974,1.974,0,0,0,9.4,4.2ZM8.174,2.224A1.224,1.224,0,0,1,9.4,1V.25A1.974,1.974,0,0,0,7.424,2.224ZM9.4,1a1.224,1.224,0,0,1,1.224,1.224h.75A1.974,1.974,0,0,0,9.4.25ZM12.76,7a3.388,3.388,0,0,0-1.138-2.069l-.49.568a2.638,2.638,0,0,1,.886,1.611ZM11.622,4.928a3.388,3.388,0,0,0-2.213-.823v.75a2.638,2.638,0,0,1,1.723.641ZM9.409,4.105A3.388,3.388,0,0,0,7.2,4.928l.49.568a2.638,2.638,0,0,1,1.723-.641ZM7.2,4.928A3.388,3.388,0,0,0,6.058,7l.742.11A2.638,2.638,0,0,1,7.686,5.5Zm-.767,2.5h5.961v-.75H6.428ZM1.708,10.733A7.212,7.212,0,0,1,2.777,7.641l-.635-.4a7.962,7.962,0,0,0-1.18,3.414ZM2.777,7.641A7.212,7.212,0,0,1,5.1,5.339L4.709,4.7A7.962,7.962,0,0,0,2.142,7.241ZM14.122,17.872a7.211,7.211,0,0,1-4.043,1.722l.07.747a7.961,7.961,0,0,0,4.463-1.9Zm-4.043,1.722a7.212,7.212,0,0,1-4.292-.944l-.377.649a7.962,7.962,0,0,0,4.738,1.042Zm3.8-14.161a7.239,7.239,0,0,1,2.973,3.9l.715-.226a7.989,7.989,0,0,0-3.281-4.3Z",
    transform: "translate(3111.875 1063.75)",
    fill: "#0e7791"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoles);
export default __webpack_public_path__ + "static/media/Roles.aac50a48283e9a234c8d6f401bd359b0.svg";
export { ForwardRef as ReactComponent };